import IMask from 'imask';

export const ID_CARD_NUMBER_BLIND_MASK = '0-0000-XXXXX-XX-0';

export const idCardNumberBlindFormatter = IMask.createPipe({
  mask: ID_CARD_NUMBER_BLIND_MASK,
});

export function removeDashes(value: string) {
  return value.replace(/-/g, '');
}
